import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './DriverDeliverySelect.css';
import Input from '../../components/UI/Input/Input';


class DriverDeliverySelect extends Component {
    state = {
        driverId: 0,
        driverSelected: false
    }

    deliverySelected = ( event ) => {
        this.props.deliveryChanged(event.target.value);       
    }

    render () {
        let driver = null;
        for (let k in this.props.drivers) {
            if (this.props.drivers[k].driverId == this.props.driverId) {
                driver = this.props.drivers[k]
            }
        }

        if (this.props.deliveries) {
            let option = [,];
            option.push({
                value: 0,
                displayValue: ""
            });
            for (let key in this.props.deliveries) {
                let entry = this.props.deliveries[key];
                if (entry.status == 'initial') { 
                    let total = entry.cedarBags + entry.hardwoodBags + entry.blackBags + entry.redBags + 10
                    if (total < driver.numberOfBags) {
                        option.push({
                            value: entry.deliveryId,
                            displayValue: entry.deliveryId  + ' (' + total + ' bags)'
                        });
                    }
                }
            }
            const options = {options: option};
            return (
                <div>
                    <Input label='Delivery' elementType='select' elementConfig={options} changed={(event) => this.deliverySelected(event)}></Input>
                </div>
            );
        }
    }
};

const mapStateToProps = state => {
 
    return {
        drivers: state.orders.drivers,
        deliveries: state.orders.deliveries
    };
}


export default connect(mapStateToProps)(DriverDeliverySelect);


// WEBPACK FOOTER //
// ./src/components/DriverDeliverySelect/DriverDeliverySelect.js